import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $clientEditProfile,
  $error,
  clientEditProfileMounted,
  updateAutoWithdrawalStatus,
  updateClient,
} from './model'

export const useClientEditProfile = () => {
  let clientEditProfile = useStore($clientEditProfile)
  const loading = useStore(updateClient.pending)
  const loadingAutoWDStatus = useStore(updateAutoWithdrawalStatus.pending)
  const error = useStore($error)

  React.useEffect(() => {
    clientEditProfileMounted()
  }, [])

  return { clientEditProfile, loading, error, loadingAutoWDStatus }
}
